// extracted by mini-css-extract-plugin
export default {"loadingContainer":"LoadingNew_loadingContainer__yiXR4","animationContainer":"LoadingNew_animationContainer__Gsfe7","animation":"LoadingNew_animation__qKHdc"};